import { render, staticRenderFns } from "./NotificationSingleView.vue?vue&type=template&id=de58dd3e&scoped=true&"
import script from "./NotificationSingleView.vue?vue&type=script&lang=js&"
export * from "./NotificationSingleView.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSingleView.vue?vue&type=style&index=0&id=de58dd3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de58dd3e",
  null
  
)

export default component.exports